import { render, staticRenderFns } from "./RecenTablesSection.vue?vue&type=template&id=4fe0ce8f&scoped=true"
import script from "./RecenTablesSection.vue?vue&type=script&lang=js"
export * from "./RecenTablesSection.vue?vue&type=script&lang=js"
import style0 from "./RecenTablesSection.vue?vue&type=style&index=0&id=4fe0ce8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe0ce8f",
  null
  
)

export default component.exports